import React from 'react';
import { Link as RouterLink } from 'react-router-dom';
import { Box, Typography, Container, Button } from '@mui/material';

function ReserveSection() {
  return (
    <Box
      sx={{
        py: { xs: 10, md: 14 },
        textAlign: 'center',
        background: 'linear-gradient(rgba(0, 0, 0, 0.85), rgba(0, 0, 0, 0.85)), url("https://images.unsplash.com/photo-1515562141207-7a88fb7ce338?q=80&w=2070&auto=format&fit=crop")',
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        backgroundAttachment: 'fixed',
      }}
    >
      <Container maxWidth="md">
        <Typography
          variant="h2"
          sx={{
            fontFamily: "'Playfair Display', serif",
            color: '#ffffff',
            mb: 3,
            fontSize: { xs: '2.5rem', md: '4rem' },
            textShadow: '0 4px 30px rgba(0,0,0,0.8)',
          }}
        >
          Secure Your Investment
        </Typography>
        
        <Typography
          variant="h6"
          sx={{
            fontFamily: "'Inter', sans-serif",
            color: '#d4af37',
            mb: 4,
            fontWeight: 400,
            letterSpacing: '2px',
            textTransform: 'uppercase',
            fontSize: '0.9rem',
          }}
        >
          Private Client Services
        </Typography>

        <Typography
          variant="body1"
          sx={{
            color: '#cccccc',
            mb: 6,
            maxWidth: '700px',
            mx: 'auto',
            lineHeight: 1.8,
          }}
        >
          Our exclusive collections are held under strict vault security. 
          Contact us today to schedule a private consultation and secure your investment.
        </Typography>

        <Button
          component={RouterLink}
          to="/contact"
          variant="outlined"
          sx={{
            borderColor: '#d4af37',
            color: '#d4af37',
            fontWeight: 600,
            fontSize: '0.85rem',
            letterSpacing: '2px',
            textTransform: 'uppercase',
            padding: '18px 50px',
            borderRadius: 0,
            '&:hover': {
              borderColor: '#ffffff',
              backgroundColor: 'rgba(212, 175, 55, 0.1)',
              color: '#ffffff',
              boxShadow: '0 5px 20px rgba(212, 175, 55, 0.2)',
            },
          }}
        >
          Contact Us
        </Button>
      </Container>
    </Box>
  );
}

export default ReserveSection;